import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { auth as authApi } from '@/api/auth';
import ErrorBanner from '@/components/ErrorBanner';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState<unknown>(null);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setSubmitting(true);
    setError(null);
    try {
      await authApi.forgotPassword(email.trim());
      setSubmitted(true);
    } catch (err) {
      setError(err);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="centered-full login-card">
      <div className="login-inner">
        <h1>Reset your password</h1>
        {submitted ? (
          <>
            <p className="muted">
              If an account exists for <strong>{email}</strong>, we&apos;ve sent a password reset link.
              Check your inbox.
            </p>
            <Link to="/login" className="btn btn-ghost">
              Back to sign in
            </Link>
          </>
        ) : (
          <>
            <p className="muted">Enter your email and we&apos;ll send you a reset link.</p>
            <form className="form-grid" onSubmit={handleSubmit}>
              {error ? <ErrorBanner error={error} /> : null}
              <label>
                <span>Email</span>
                <input
                  className="input"
                  type="email"
                  autoComplete="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </label>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={submitting || !email}
              >
                {submitting ? 'Sending…' : 'Send reset link'}
              </button>
            </form>
            <div className="login-links">
              <Link to="/login">Back to sign in</Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
